// @flow

import _ from 'lodash/fp';
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import SelectFormInput from '../SelectFormInput/SelectFormInput';

export type Props = {
  apartmentConfig: ?any,
  apartmentConfigs: any[],
  configTemplates: any[],
  formValues: any,
  onUserChange: Function,
  apartments: any[],
};

const ApartmentConfigForm = ({apartmentConfig, apartmentConfigs, configTemplates, formValues, onUserChange, apartments}: Props) => {
  return  <div className="ApartmentConfigForm">
    <div className="row">
      <div className="small-6 column">
        <Field
          name="name"
          label="Namn"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        {(!apartmentConfig || !apartmentConfig.id) && (
          <div onChange={onUserChange}>
            <label>
              Lägenhet
            </label>
            <Field
              name="apartmentId"
              component={SelectFormInput}
              clearable={true}
              normalize={value => value ? value.id : null}
              placeholder="Välj lägenhet"
              valueKey="id"
              labelKey="objectId"
              options={_.filter(a => a.state === 0 && !a.hasOrders, apartments)} />

            <label>
              Rum
            </label>
            <label>
              <Field
                name="rooms"
                component="input"
                type="radio"
                value="NONE" /> Lägg till manuellt
            </label>
            <label>
              <Field
                name="rooms"
                component="input"
                type="radio"
                value="CONFIG" /> Kopiera från konfiguration
            </label>
            <Field
              name="basedOnConfigId"
              component={SelectFormInput}
              normalize={value => value ? value.id : null}
              disabled={!formValues || formValues.rooms !== 'CONFIG'}
              placeholder="Välj konfiguration"
              valueKey="id"
              labelKey="name"
              options={apartmentConfigs} />
            <label>
              <Field
                name="rooms"
                component="input"
                type="radio"
                value="TEMPLATE" /> Basera på mall
            </label>
            <Field
              name="basedOnTemplateId"
              component={SelectFormInput}
              normalize={value => value ? value.id : null}
              disabled={!formValues || formValues.rooms !== 'TEMPLATE'}
              placeholder="Välj mall"
              valueKey="id"
              labelKey="name"
              options={configTemplates} />

          </div>
        )}
      </div>
    </div>
  </div>;
};

export default reduxForm({
  form: 'apartmentConfig',
  enableReinitialize: true,
})(ApartmentConfigForm);



// WEBPACK FOOTER //
// ./src/components/ApartmentConfigForm/ApartmentConfigForm.js